import { useEffect, useRef, useState } from "react";
import Radar from "radar-sdk-js";
import "radar-sdk-js/dist/radar.css";

import classes from "./PickupPannel.module.css";
import SearchIcon from "../../icons/searchicon";

const incompleteAddressMessage = 'The address provided seems incomplete. Please ensure you enter your full address.'
const addressNotFoundMessage = "We couldn't find that address. Please select one from the list."

const AutocompleteComponent = ({selectedResult, loading, setError, setValue, setAddressDetails, inputError, label}) => {
    const autocompleteRef = useRef(null)
    const commitAddressRef = useRef(() => {})

    const [geocoding, setGeocoding] = useState(false)

    const commitAddress = (address) => {
        if (!address) {
            selectedResult(null)
            return
        }

        let postal_code = false
        let city = false
        let street_number = false
        let street = false

        let addrressDetails = {
            postal_code: '',
            city: '',
            street_number: '',
            street: '',
            full_address: ''
        }

        if(address.city) {
            city = true
            addrressDetails.city = address.city
        }
        if (address.postalCode) {
            postal_code = true
            addrressDetails.postal_code = address.postalCode
        }
        
        if(address.number) {
            street_number = true
            addrressDetails.street_number = address.number
        }
        if(address.street) {
            street = true
            addrressDetails.street = address.street
        }

        if (postal_code && city && street_number && street && address.latitude != null && address.longitude != null) {
            setError(null)
            setValue(address.formattedAddress)
            if (autocompleteRef.current && address.formattedAddress) {
                autocompleteRef.current.value = address.formattedAddress
            }
            addrressDetails.full_address = address.formattedAddress
            setAddressDetails(addrressDetails)
            selectedResult(address)
        } else {
            setError(incompleteAddressMessage)
        }
    }

    commitAddressRef.current = commitAddress

    useEffect(() => {
        Radar.initialize(process.env.REACT_APP_RADAR_MAPS, {});

        if (autocompleteRef) {
            Radar.ui.autocomplete({
                container: 'radar_autocomplete',
                countryCode: 'US',
                // layers: ['address'],
                style: {
                    position: 'absolute',
                    backgroundColor: 'red'
                },
                onSelection: (address) => {
                    commitAddressRef.current(address)
                },
            });
        }       


    }, []);

    const searchOnClick = () => {
        if (loading || geocoding) {
            return
        }

        const query = autocompleteRef.current?.value?.trim()
        if (!query) {
            selectedResult(null)
            return
        }

        setGeocoding(true)
        Radar.forwardGeocode({ query, country: 'US', layers: ['address'] })
            .then((result) => {
                const address = result?.addresses?.find(item => item.confidence !== 'fallback')
                if (address) {
                    commitAddress(address)
                } else {
                    setError(addressNotFoundMessage)
                }
            })
            .catch(() => {
                setError(addressNotFoundMessage)
            })
            .finally(() => {
                setGeocoding(false)
            })
    }

    const showLoader = loading || geocoding

    return <div className="form-fields-container">
        
        <label className={'label label-caps'} htmlFor='searchAddress'>{label ? label : 'Enter an address'}</label>
        <div className={classes.form_input_container}>
            <input type='text' /* placeholder='City, State or Zip Code' */ id="radar_autocomplete" ref={autocompleteRef} className={`${inputError ? 'error' : ''}`} required/>
            <button className={classes.btn_simple} type="button" onClick={searchOnClick}>
                {showLoader && <span className="loader"></span>}
                {!showLoader && <SearchIcon />}
                <span className="sr-only">Search location</span>
            </button>
        </div>
        
    </div>
}

export default AutocompleteComponent
